/**
 * Форматировать дату в локальный формат
 */
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * Форматировать дату в относительный формат (например, "2 часа назад")
 */
export const formatRelativeTime = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'только что';
  if (diffMins < 60) return `${diffMins} мин. назад`;
  if (diffHours < 24) return `${diffHours} ч. назад`;
  if (diffDays < 7) return `${diffDays} дн. назад`;
  
  return formatDate(dateString);
};

/**
 * Форматировать оставшееся время
 */
export const formatTimeRemaining = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = date - now;
  
  if (diffMs <= 0) return 'истёк';
  
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 60) return `${diffMins} мин.`;
  if (diffHours < 24) return `${diffHours} ч.`;
  return `${diffDays} дн.`;
};

/**
 * Сократить длинный текст с добавлением многоточия
 */
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

/**
 * Форматировать размер данных
 */
export const formatBytes = (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes) || bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

/**
 * Получить цвет статуса токена
 */
export const getTokenStatusColor = (status) => {
  switch (status) {
    case 'active':
      return 'green';
    case 'expired':
      return 'red';
    case 'revoked':
      return 'gray';
    default:
      return 'gray';
  }
};

/**
 * Получить цвет статуса прокси
 */
export const getProxyStatusColor = (status) => {
  switch (status) {
    case 'online':
      return 'green';
    case 'offline':
      return 'gray';
    case 'error':
      return 'red';
    default:
      return 'gray';
  }
};

/**
 * Форматировать список портов
 */
export const formatPorts = (ports) => {
  if (!ports || ports.length === 0) return '-';
  
  return ports.map(p => `${p.protocol}/${p.port}`).join(', ');
};

/**
 * Скопировать текст в буфер обмена
 */
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy text: ', err);
    return false;
  }
};

/**
 * Получить цвет статуса сессии
 */
export const getSessionStatusColor = (status) => {
  switch (status) {
    case 'active':
      return 'green';
    case 'closed':
      return 'gray';
    default:
      return 'gray';
  }
};

/**
 * Форматировать длительность сессии
 */
export const formatDuration = (milliseconds) => {
  if (!milliseconds || milliseconds < 0) return '-';

  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days}д ${hours % 24}ч ${minutes % 60}м`;
  } else if (hours > 0) {
    return `${hours}ч ${minutes % 60}м`;
  } else if (minutes > 0) {
    return `${minutes}м ${seconds % 60}с`;
  } else {
    return `${seconds}с`;
  }
};

/**
 * Форматировать трафик (получено/отправлено)
 */
export const formatTraffic = (bytesSent, bytesReceived) => {
  // Преобразуем в число, если значение строка или undefined
  const sentNum = typeof bytesSent === 'string' ? parseFloat(bytesSent) : (bytesSent || 0);
  const receivedNum = typeof bytesReceived === 'string' ? parseFloat(bytesReceived) : (bytesReceived || 0);

  const sent = formatBytes(isNaN(sentNum) ? 0 : sentNum);
  const received = formatBytes(isNaN(receivedNum) ? 0 : receivedNum);
  return `↓ ${received} / ↑ ${sent}`;
};
